module.exports = __webpack_public_path__ + "static/media/3DPPA17.81a1557d.jpg";